'use client';

import { useSuspenseQuery } from '@apollo/client/react';
import { FC, PropsWithChildren, useMemo } from 'react';

import { User } from '@/.gql/graphql';
import { GET_ME_SUBSCRIBERS } from '@/.graphql';

import { createCustomContext } from './context';

interface ISubscribersProps {
  mySubscribers: Array<User>;
}

const [SubscribersForMeContext, useSubscribersForMeContext] =
  createCustomContext<ISubscribersProps>({
    name: 'SubscriptionsContext',
    strict: false,
  });

export { useSubscribersForMeContext };

export const SubscribersForMeProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  const { data } = useSuspenseQuery(GET_ME_SUBSCRIBERS);

  const mySubscribers = useMemo(() => data?.getMeSubscribers ?? [], [data]);

  const contextValue = useMemo(() => ({ mySubscribers }), [mySubscribers]);

  return (
    <SubscribersForMeContext value={contextValue}>
      {children}
    </SubscribersForMeContext>
  );
};
